/* eslint-disable no-unused-vars */

import React from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { slices, useAppDispatch, useAppSelector } from 'src/redux';
import { ProductPriceListData, UpdateProductThunkRequest } from 'src/types';
import { stringToNumberArr } from 'src/utils';
import {
  initialQuery,
  queryParamsInterface
} from 'src/views/price-list/constants';
import { ComponentPBData } from 'src/redux/slices/product';
import { FilterStockEnum } from 'src/enums/product/status';

const { actions: productActions, selectors: productSelectors } = slices.product;

//lets reuse this code
export const usePriceList = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const productPriceList = useAppSelector(
    productSelectors.selectProductPriceList
  );
  const priceListDate = useAppSelector(productSelectors.selectPriceListDate);
  const params = useAppSelector(productSelectors.selectPriceListParams);
  const meta = useAppSelector(productSelectors.selectProductPriceListMeta);
  const isLoading = useAppSelector(
    productSelectors.selectIsProductPriceListLoading
  );
    const poweredBuildsComponentData = useAppSelector(
    productSelectors.selectPoweredBuildsComponent
  );

  const [tabValue, setTabValue] = useState<number>(0);

  const handleTabChange = (search: string, tabValue: number) => {
    navigate({ search: `tab=${tabValue}` }, { replace: true });
  };

  const setParams = (params: queryParamsInterface) => {
    dispatch(productActions.setPriceListParams(params));
  };

  const getPriceList = useCallback(
    async (params: { [key: string]: any } = {}) => {
      let res;
      const {
        keyword,
        sort_by,
        page,
        category_id,
        branch_ids,
        tab,
        sort_by_column,
        product_filter
      } = params;

      const formattedParams = {
        ...(keyword && { keyword: keyword }),
        ...(sort_by && { sort_by: +sort_by }),
        ...(category_id && { category_id: +category_id }),
        ...(tab && { tab: +tab }),
        ...(sort_by_column && { sort_by_column: sort_by_column }),
        ...(branch_ids && {
          branch_ids: stringToNumberArr(params?.branch_ids)
        }),
        ...(product_filter !== undefined ? { product_filter } : { product_filter: FilterStockEnum.InStocks }),
        page: page ? +page : 1
      };

      switch (params.tab) {
        case '1':
          res = unwrapResult(
            await dispatch(
              productActions.getPoweredBuildsPriceListThunk(formattedParams)
            )
          );
          break;
        case '2':
          res = unwrapResult(
            await dispatch(
              productActions.getIncomingPriceListThunk(formattedParams)
            )
          );
          break;
        default:
          res = unwrapResult(
            await dispatch(productActions.getPriceListThunk(formattedParams))
          );
      }

      if (res?.originalData?.success) {
        let paramsClone = { ...formattedParams };
        // remove page from being passed to url due to different pagination usage
        delete paramsClone['page'];

        // set params in state for displaying for pagination
        setParams(paramsClone);
      } else {
        console.error('Error in: getPriceList');
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps, no-undef
    [dispatch]
  );

  const onLoadMoreItems = () => {
    let newPage = meta?.current_page ? meta.current_page + 1 : 1;
    let lastPage = meta?.last_page ?? 1;

    if (newPage <= lastPage) {
      getPriceList({
        ...params,
        page: newPage,
        ...(params?.branch_ids?.[0] && {
          branch_ids: params?.branch_ids.join(',') // re-joined to string because that is expected
        })
      });
    }
  };

  const onUpdatePriceList = async (item: ProductPriceListData) => {
    const newProductData: UpdateProductThunkRequest = {
      category_id: item?.category_id,
      id: item?.id,
      retail_price: item?.retail_price,
      ram_kit: item?.ram_kit,
      pricelist_edit: true,
      ...(item?.recompute_bundle_price
        ? { recompute_bundle_price: true }
        : { recompute_bundle_price: false })
    };
    dispatch(productActions.updateProductsThunk(newProductData)).finally(() => {
      const itemList = productPriceList.map((data) =>
        data.id === item.id ? item : data
      );
      dispatch(productActions.setProductPriceList(itemList));
    });
  };

  const onHandlePoweredBuildsProductIds=(state:ComponentPBData)=>{
        dispatch(productActions.setPoweredBuildsProductComponentIds(state));
  }

  return {
    priceListDate,
    isLoading,
    params,
    tabValue,
    initialQuery,
    productPriceList,
    poweredBuildsComponentData,
    meta,

    setParams,
    onUpdatePriceList,
    onLoadMoreItems,
    getPriceList,
    handleTabChange,
    setTabValue,
    onHandlePoweredBuildsProductIds
  };
};
